import {appConfig} from '../config'

export function getPassportRetpath(windowLocation: Location['href']) {
  const location = new URL(windowLocation)
  const {zoneName} = appConfig.initialProps

  if (zoneName) {
    const segments = location.pathname.split('/')

    if (segments.includes(zoneName)) {
      location.pathname = segments
        .filter(segment => segment && segment !== zoneName)
        .join('/')
    }
  }

  location.searchParams.set('origin', 'dostavka')

  return location.toString()
}
